import { useCallback, useMemo } from 'react'
import type { BoxTruckMapDriver } from '../services/boxTruckLoadsApi'
import type { DriverClusterInspection, MapViewport } from '../types/boxTruckMap'
import { buildDriverClusterIndex, getDriverClusterExpansionZoom, getDriverClusterInspection, getDriverMapPoints } from '../utils/driverMapClusters'

interface UseDriverMapClustersOptions {
    drivers: BoxTruckMapDriver[]
    viewport: MapViewport
}

export const useDriverMapClusters = ({ drivers, viewport }: UseDriverMapClustersOptions) => {
    const driverById = useMemo(() => new Map(drivers.map((driver) => [driver.driverId, driver])), [drivers])
    const index = useMemo(() => buildDriverClusterIndex(drivers), [drivers])
    const points = useMemo(() => getDriverMapPoints(index, driverById, viewport.bounds, viewport.zoom), [driverById, index, viewport])

    const getClusterExpansionZoom = useCallback((clusterId: number): number => getDriverClusterExpansionZoom(index, clusterId), [index])
    const getClusterInspection = useCallback(
        (clusterId: number, totalCount: number): DriverClusterInspection => getDriverClusterInspection(index, driverById, clusterId, totalCount),
        [driverById, index]
    )

    return { points, getClusterExpansionZoom, getClusterInspection }
}
